import React from 'react'
import PropTypes from 'prop-types'
import classes from '../app.module.css'
import classNames from 'classnames'

const HorizontalSpinner = props => (
  <div className={classNames(classes.horizontalSpinner, props.className)} style={props.style}>
    <div className={classes.bounce1} />
    <div className={classes.bounce2} />
    <div />
  </div>
)

HorizontalSpinner.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.object
}

export default HorizontalSpinner
